import { pageHead } from "@/lib/routeHead";
import { createFileRoute, notFound } from "@tanstack/react-router";
import PublicJobApplyPage from "@/pages/PublicJobApplyPage";
import { publicJobQuery } from '@/lib/publicJobs';
import { PublicJobError } from '@/components/PublicJobError';
import { PortalNotFound } from '@/components/PortalNotFound';

export const Route = createFileRoute("/careers/jobs/$slug/apply")({
  loader: async ({ context, params }) => {
    const result = await context.queryClient.ensureQueryData(publicJobQuery(params.slug));
    if (!result.job) throw notFound();
    return result;
  },
  head: ({ loaderData, params }) => pageHead(
    loaderData?.job ? `Apply: ${loaderData.job.title} | AKIVA Careers` : 'Position Unavailable | AKIVA Careers',
    loaderData?.job ? `Submit your application for the ${loaderData.job.title} position at AKIVA.` : 'This position is unavailable.',
    `/careers/jobs/${params.slug}/apply`, true,
  ),
  errorComponent: PublicJobError,
  notFoundComponent: PortalNotFound,
  component: PublicJobApplyPage,
});
